
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's1488e73779d7682f': `1) Ανοίξτε το μενού του περιηγητή σας`,
's182ab2d6c997515f': `Προσθέστε το στην Οθόνη Αφετηρίας για εκτεταμένη εμπειρία και εύκολη πρόσβαση.`,
's1b9047d53d9f9d22': `2) Πατήστε "Κοινή χρήση" στη γραμμή πλοήγησης`,
's2d90afa5dcca2c0e': `3) Κάντε κύλιση προς τα κάτω στο "Προσθήκη στην οθόνη Αφετηρίας"`,
's37a9e8aec5713460': `Περισσότερα`,
's4593f304dac8848c': `2) Πατήστε "Προσθήκη στην οθόνη Αφετηρίας"`,
's54cfbb14f46396d4': `1) Ανοίξτε στον κύριο περιηγητή σας`,
's6196153c4b0c1ea0': `Εγκατάσταση`,
's922329d6f6213590': `Προσθήκη στο Dock`,
'sa5ef80b4bb9b39f8': `Λιγότερα`,
'sa7551383d1897fcc': `2) Πατήστε "Προσθήκη στο Dock"`,
'sba52286c21552a4e': `Εγκαταστήστε το στη συσκευή σας για εκτεταμένη εμπειρία και εύκολη πρόσβαση.`,
'sc79fd7641eb9a975': `Απόκρυψη Οδηγιών`,
'scdaf4bbff76674c8': `Προσθήκη στην οθόνη Αφετηρίας`,
'se740f75b95a51807': `Προσθέστε το στο Dock για εκτεταμένη εμπειρία και εύκολη πρόσβαση.`,
'sfea652f6580ff086': `Αυτός ο ιστότοπος έχει λειτουργικότητα εφαρμογής.`,
    };
  